import Vue from 'vue';
import Vuex from 'vuex';
import { factory as UserFactory } from 'stores/user';
import { factory as CorpFactory } from 'stores/corp';
import { factory as SystemFactory } from 'stores/system';
import { factory as PopupPanelFactory } from 'stores/popupPanel';
import { factory as SubscriptionFeaturesFactory } from 'stores/subscriptionFeatures';
import staffStore from 'stores/staffsStore';
import { factory as SubscriptionManagerFactory } from 'stores/sellsyaccountmanager/subscriptionManager';

/**
 * Store service can be used to retrieve data from shared store.
 * It should not be used in a Vue component on computed attributes
 * because it does not support store mutations (you will lose component reactivity).
 *
 * It is supposed to be mostly used in legacy code.
 * For Vuex store usage in Vue components, see {@see https://vuex.vuejs.org/guide/state.html}.
 */
export default class Store {
    /**
     * @param {Object} intlConfig
     * @param {Object} user
     * @param {Object} corporation
     * @param {Object} system
     * @param {Object} subscription_features
     */
    static async set(
        intlConfig,
        user,
        corporation,
        system,
        subscriptionFeatures,
        sellsySubscriptionDictionnary,
    ) {
        Vue.use(Vuex);

        this.intlConfig = intlConfig;
        this.user = user;
        this.corporation = corporation;
        this.system = system;
        this.subscription_features = subscriptionFeatures;
        this.sellsy_subscription_dictionnary = sellsySubscriptionDictionnary;

        this.store = new Vuex.Store({
            modules: {
                user: UserFactory({ ...window.App, ...this.intlConfig, ...this.user }),
                corp: CorpFactory({ ...window.App, ...this.intlConfig, ...this.corporation }),
                system: SystemFactory(this.system),
                popupPanel: PopupPanelFactory(),
                staffs: staffStore,
                subscriptionFeatures: SubscriptionFeaturesFactory(this.subscription_features),
                subscriptionManager: SubscriptionManagerFactory(
                    this.sellsy_subscription_dictionnary,
                ),
            },
        });
    }

    /**
     * @param {string} key
     * @returns {Object}
     */
    static get(key) {
        return this.store.state[key];
    }

    /**
     * @returns {Vuex.Store}
     */
    static getStates() {
        return this.store;
    }
}
